import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as ChatActions from './chat.actions';
import * as ChatSelectors from './chat.selectors';

import { IConversationData, IMessage } from '../../interfaces/conversations.interfaces';

@Injectable({
  providedIn: 'root'
})
export class ChatFacade {
  conversations$: Observable<IConversationData[]> = this.store.select(
    ChatSelectors.selectConversations
  );
  selectedConversationId$: Observable<string> = this.store.select(
    ChatSelectors.selectSelectedConversationId
  );

  conversationsSortedByTimestamp$: Observable<IConversationData[]> = this.store.select(
    ChatSelectors.selectConversationsSortedByTimestamp
  );

  constructor(private readonly store: Store) {}

  addConversation(conversation: IConversationData): void {
    this.store.dispatch(ChatActions.addConversation({ conversation }));
  }

  updateConversation(conversationId: string, updates: Partial<IConversationData>): void {
    this.store.dispatch(ChatActions.updateConversation({ conversationId, updates }));
  }

  selectConversation(conversationId: string): void {
    this.store.dispatch(ChatActions.selectConversation({ conversationId }));
  }

  toggleChatsFullScreen(isFullScreen: boolean): void {
    this.store.dispatch(ChatActions.toggleChatsFullScreen({ isFullScreen }));
  }

  setConversations(conversations: IConversationData[]): void {
    this.store.dispatch(ChatActions.setConversations({ conversations }));
  }

  updateConversationOffset(conversationId: string, offset: string): void {
    this.store.dispatch(ChatActions.updateConversationOffset({ conversationId, offset }));
  }

  clearConversations(): void {
    this.store.dispatch(ChatActions.clearConversations());
  }

  updateMessageByTimestamp(conversationId: string, message: IMessage, timestamp: number): void {
    this.store.dispatch(
      ChatActions.updateMessageByTimestamp({ conversationId, message, timestamp })
    );
  }

  getConversations(): IConversationData[] {
    let conversations: IConversationData[] = [];
    this.conversations$.subscribe(conv => (conversations = conv)).unsubscribe();
    return conversations;
  }
}
